import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import BaseElement from './BaseElement';

export function renderTextElement(params) {
  return (props) => {
    if (props.element.type === 'text') { 
      return (
          <TextElement {...props} {...params} />
      );
    }
  
    return undefined;
  }
}

// const params = {
//   setCurrentElement
// }

export const TextPlugin = (params = {}) => ({
  renderElement: renderTextElement(params),
});

export default function TextElement({ attributes, children, element, ...props }) {
  const { t } = useTranslation();

  return (
    <BaseElement type="text" element={element} {...props} {...attributes}>
      {
        ({ isEmpty }) => (
          <React.Fragment>
            {isEmpty && <BaseElement.Placeholder text={t('editor.items.text')} />}
            {/* <div {...attributes}> */}
              {children}
            {/* </div> */}
          </React.Fragment>
        )
      }  
    </BaseElement>
  )
}
